import * as ReduxObservable from 'redux-observable'
import * as Form from '../../components/form'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'

type Epic = ReduxObservable.Epic<any, ApplicationState>
export const onEnter: Epic = (action$, store, {history}) =>
  action$.ofType(
    Router.ON_ENTER,
    Request.successConstant(Constants.UPDATE_CAMPAIGN),
    Request.successConstant(Constants.UPDATE_CAMPAIGN_TIER),
  )
  .filter(() => history.location.pathname.startsWith(Menu.NEWSLETTER_CAMPAIGNS_URL))
  .map(store.getState)
  .map(({app}) => Actions.fetchReferralCampaigns(app.selectedCommunity))

export const campaignSave: Epic = (action$, store) =>
  action$.ofType(Constants.CampaignFormConstantsMap[Form.SAVE])
    .map(store.getState)
    .map(({app: {selectedCommunity}, referralCampaigns: {campaignForm}}) =>
      ({campaignFields:
        campaignForm.fields.id ?
          {...Form.modifiedFields(campaignForm), id: campaignForm.fields.id} :
          campaignForm.fields,
        selectedCommunity}))
    .map(({campaignFields, selectedCommunity}) => campaignFields.id ?
        Actions.updateReferralCampaign(selectedCommunity, campaignFields as Types.Campaign) :
        Actions.createReferralCampaign(selectedCommunity, campaignFields as Types.Campaign))

export const tierSave: Epic = (action$, store) =>
  action$.ofType(Constants.TierFormConstantsMap[Form.SAVE])
    .map(store.getState)
    .map(({app: {selectedCommunity}, referralCampaigns: {tierForm}}) =>
      ({selectedCommunity,
        tierFields:
        tierForm.fields.id ?
          {...Form.modifiedFields(tierForm), id: tierForm.fields.id} :
          tierForm.fields}))
    .map(({selectedCommunity, tierFields}) => tierFields.id ?
        Actions.updateReferralCampaignTier(selectedCommunity, tierFields as Types.Tier) :
        Actions.createReferralCampaignTier(selectedCommunity, tierFields as Types.Tier))

export const onSuccess: Epic = (action$, store) =>
  action$.ofType(
    Request.successConstant(Constants.UPDATE_CAMPAIGN),
    Request.successConstant(Constants.UPDATE_CAMPAIGN_TIER),
    Request.errorConstant(Constants.UPDATE_CAMPAIGN),
    Request.errorConstant(Constants.UPDATE_CAMPAIGN_TIER),
  )
  .mergeMap(() => [
    Actions.CampaignFormActions[Form.RESET](),
    Actions.TierFormActions[Form.RESET](),
  ])

export const epic = ReduxObservable.combineEpics(onEnter, campaignSave, tierSave, onSuccess)



// WEBPACK FOOTER //
// ./src/pages/referral-campaigns/epic.ts